import { InputHTMLAttributes, useEffect, useRef } from 'react';
import { clsx } from 'clsx';

import { Icons } from '@monoimin/atoms';
import { IconNamesUnion } from '@monoimin/sb-types';

import { InputLabel } from '@monoimin/atoms/components/InputLabel';

type InputProps = Pick<
  InputHTMLAttributes<HTMLInputElement>,
  | 'className'
  | 'type'
  | 'placeholder'
  | 'value'
  | 'onChange'
  | 'onKeyDown'
  | 'min'
  | 'max'
> & {
  icon?: IconNamesUnion;
  size: 'small' | 'large';
  autofocus?: boolean;
};

export const Input = ({
  className,
  icon,
  type,
  value,
  placeholder,
  onKeyDown,
  onChange,
  min,
  max,
  size,
  autofocus,
}: InputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const haveValue = Boolean(value);

  useEffect(() => {
    if (inputRef.current && autofocus) {
      inputRef.current.focus();
    }
  }, [autofocus]);

  return (
    <div
      className={clsx('real-estate-input', className, {
        'real-estate-input_size_large': size === 'large',
        'real-estate-input_size_small': size === 'small',
        'real-estate-input_changed': haveValue,
        'real-estate-input_unchanged': !haveValue,
      })}
    >
      {icon && (
        <Icons
          icon={icon}
          className='real-estate-input__icon bg-grey-light mr-1'
          sizeClassName='h-7'
          isInteractive
          data-testid='icon-search'
        />
      )}
      <InputLabel title={placeholder} isActive={haveValue} />
      <input
        ref={inputRef}
        min={min}
        max={max}
        type={type}
        onKeyDown={onKeyDown}
        className='real-estate-input__controller body'
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
